const CenterCard = (props) => {
    const {children, extraClasses, color} = props
    return(
            <div className={`rounded-2xl ${color?color:"bg-color2 md:p-4 p-2"} m-auto shadow-2xl ${extraClasses}`}>
                {children}
            </div>
    )
}
export default CenterCard